import {ConfirmationDialog, name} from '@management-ui/core';
import {PictureAsPdf, Send} from '@mui/icons-material';
import {Alert, IconButton, Menu, MenuItem, Snackbar, Tooltip} from '@mui/material';
import * as React from 'react';
import {useCallback, useContext, useEffect, useState} from 'react';
import {ServiceContext} from '../../../../../components/Services';
import Table from '../../../../../components/Table';
import {vehicleTitle} from '../../../../../formatters';

const Certificates = ({job, contacts}) => {
  const services = useContext(ServiceContext);
  const [showSent, setShowSent] = useState(false);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showContacts, setShowContacts] = useState(false);
  const [showNotify, setShowNotify] = useState(false);
  const [contact, setContact] = useState(null);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(
      job.products
        .filter(({product}) => product.requires_certificate)
        .map(({product, items}) => items.filter(item => !!item.job && !!item.vehicle).map(item => ({
          id: item.id,
          product: product.name,
          serial: item.serial_number ?? '-',
          location: item.location?.name ?? '-',
          vehicle: item.vehicle ? vehicleTitle(item.vehicle) : '-',
        })))
        .flat()
    );
  }, [job]);

  const handleDownload = useCallback((item) => {
    setLoading(true);
    services.stockItem.downloadCertificate(item).then(() => {
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [services]);

  const handleNotify = useCallback(confirmed => {
    setShowNotify(false);
    if (confirmed) {
      setLoading(true);
      services.stockItem.sendCertificate(selected, contact).then(() => {
        setShowSent(true);
        setLoading(false);
      }).catch(() => setLoading(false));
    }
  }, [services, selected, contact]);

  return (
    <>
      <Table className={loading ? 'loading' : ''}>
        <Table.Row>
          <Table.Header>Product</Table.Header>
          <Table.Header>Serial Number</Table.Header>
          <Table.Header>Location</Table.Header>
          <Table.Header>Vehicle</Table.Header>
          <Table.Action/>
          <Table.Action/>
        </Table.Row>
        {items.length > 0 ? (
          items.map((item, index) => (
            <Table.Row key={index}>
              <Table.Column>{item.product}</Table.Column>
              <Table.Column>{item.serial}</Table.Column>
              <Table.Column>{item.location}</Table.Column>
              <Table.Column>{item.vehicle}</Table.Column>
              <Table.Action>
                <Tooltip title="Download Certificate">
                  <IconButton onClick={() => handleDownload(item)}>
                    <PictureAsPdf/>
                  </IconButton>
                </Tooltip>
              </Table.Action>
              <Table.Action>
                <Tooltip title="Send Certificate">
                  <IconButton
                    onClick={e => setMenuAnchor(e.currentTarget) || setSelected(item) || setShowContacts(true)}>
                    <Send/>
                  </IconButton>
                </Tooltip>
              </Table.Action>
            </Table.Row>
          ))
        ) : (
          <Table.NoRecords>There are no items with a certificate associated with this job</Table.NoRecords>
        )}
      </Table>
      <ConfirmationDialog
        title="Send to Customer"
        message={contact ? `Are you sure you want to send this installation certificate to ${contact.email}?` : ''}
        open={showNotify}
        onClose={handleNotify}
      />
      <Menu
        anchorEl={menuAnchor}
        open={showContacts}
        onClose={() => setShowContacts(false)}
      >
        {contacts.map((c, index) => (
          <MenuItem key={index} onClick={() => setContact(c.contact) || setShowContacts(false) || setShowNotify(true)}>
            {name(c.contact)} ({c.contact.email})
          </MenuItem>
        ))}
      </Menu>
      <Snackbar open={showSent} autoHideDuration={4000} onClose={() => setShowSent(false)}>
        <Alert onClose={() => setShowSent(false)} severity="success">
          The certificate has been sent
        </Alert>
      </Snackbar>
    </>
  );
};

export default Certificates;
